export const numOnly = (event) => {
  if (!(event.which > 47 && event.which < 58) || event.which === 13)
    event.preventDefault();
};

export const alphaNumeric = (event) => {
  let key = event.keyCode;

  if (
    !(key > 47 && key < 58) && // numeric (0-9)
    !(key > 64 && key < 91) && // upper alpha (A-Z)
    !(key > 96 && key < 123) &&
    !(key === 8 || key === 46) &&
    !(key === 37 || key === 38 || key === 39 || key === 40) &&
    !(key === 191 || key === 189 || key === 32 || key === 9) &&
    !(key === 96)
  ) {
    // lower alpha (a-z)
    event.preventDefault();
  }

  if (key === 106 || key === 107 || key === 110) {
    event.preventDefault();
  }

  if (event.shiftKey && key > 47 && key < 58) {
    event.preventDefault();
  }
};
export const convert = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
function createPreview(fileInput) {
  let blob = new Blob(fileInput?.target?.files, {
    type: fileInput?.target?.files[0]?.type,
  });

  return URL.createObjectURL(blob);
}
export const onlyOneSpace = (evt) => {
  var startPos = evt.currentTarget.selectionStart;
  if (evt.which === 32) {
    //Prevents spaces in Beginning and more than on at the end
    if (
      startPos === 0 ||
      (startPos === evt.target.value.length &&
        evt.target.value[evt.target.value.length - 1] === " ")
    ) {
      evt.preventDefault();
    }
  }
};
